
<template>
  <div style="width: 100%;height: 100%; position:relative">
    <div ref="chart"
         style="width: 100%;height: 100%;"></div>
    <div class="info">{{echartData.title}}</div>

  </div>
</template>

<script>
import imgSrc from '../../../images/chartCenterRight.png'
export default {
  name: 'ChartPie1',
  props: {
    // echartData: {
    //   type: Object
    // }
  },
  data () {
    return {
      imgSrc,
      myChart: null,
      echartData: {}
    }
  },
  mounted () {
    setTimeout(() => {
      this.getData()
    }, 200)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    getData () {
      if (Object.keys(this.echartData).length !== 0) {
        const data1 = this.echartData.data.map(item => {
          const target = {
            ...item
          }
          target.itemStyle = {
            opacity: 0.2
          }
          return target
        })
        this.getChart({
          data: this.echartData.data,
          data1,
          color: this.echartData.color,
          count: this.echartData.count
        })
      }
    },
    getChart (o) {
      const chart = this.$refs.chart
      if (chart) {
        if (this.myChart) {
          this.myChart.dispose()
        }
        this.myChart = this.$echarts.init(chart)
        var option = {
          // title: {
          //   text: '水稻政策性保险',
          //   bottom: 0,
          //   left: 'center',

          //   textStyle: {
          //     color: 'rgba(202, 229, 255, 1)',
          //     fontSize: 12,
          //     fontWeight: 'normal'

          //   }
          // },
          color: o.color,
          tooltip: {
            trigger: 'item',
            formatter: function (item) {
              // console.log('悬浮层',item)
              if (item.seriesIndex == 2) {
                return ``
              } else {
                return `${item.marker} ${item.name}: ${item.value}万亩`
              }
            }
          },
          legend: {
            show: false,
            // left: 'center',
            // // x: 'center',
            // itemHeight: 8,
            // itemWidth: 8,
            // bottom: 10,
            // // width: 400,//给整个图例组件这只宽度,如果不设置,图例将根据容器大小自适应
            // data: o.data,
            // formatter: (params) => {
            //   let value = o.data.filter(i => i.name === params)[0].value

            //   let total = o.data.reduce((prev, curVal) => prev + curVal.value, 0)

            //   let percent = (value / total * 100).toFixed(0) + '%'

            //   return `{a|${params}}{b|${percent}}{c|${value}个}`
            // },
            textStyle: {
              rich: {
                a: {
                  width: 30,
                  fontSize: 10,
                  lineHeight: 12,
                  color: 'rgba(204, 204, 204, 1)'
                },
                b: {
                  width: 30,
                  fontSize: 10,
                  lineHeight: 12,
                  color: 'rgba(71, 238, 190, 1)'
                },
                c: {
                  width: 40,
                  fontSize: 10,
                  lineHeight: 12,
                  color: 'rgba(255, 255, 255, 1)'
                }
              }

            }
          },
          grid: {
            top: '0%',
            left: '0%',
            right: '0%',
            bottom: '0%',
            containLabel: true
          },
          graphic: { // 这个属性可以在饼图内部填充图片,文字等
            z: 3,
            elements: [{
              type: 'image', // 需要填充图片,配置image,如果不需要图片可以配置其他的, text, circle, sector, ring, polygon, polyline, rect, line, bezierCurve, arc, group,
              style: {
                image: this.imgSrc, // 这里添加图片地址
                width: this.myChart.getWidth() * 0.3,
                height: this.myChart.getWidth() * 0.3
              },
              // center: ['40%', '50%']
              left: 'center', //
              top: 'center' // 配置图片居中
            }]
          },

          series: [
            // 外圈
            {
              type: 'pie',
              radius: ['50%', '72%'],
              center: ['50%', '50%'],
              // z: 2,

              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                borderRadius: 0,
                borderColor: '#092729',
                borderWidth: 3
              },
              labelLine: {
                show: true,
                length: 5
              },
              emphasis: {
                label: {
                  show: false,
                  title: '#fff',
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              },
              data: o.data1
            },
            // 内圈
            {
              type: 'pie',
              radius: ['45%', '60%'],
              center: ['50%', '50%'],
              // avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  position: 'center',
                  formatter: function () {
                    let counts = o.count + '%'
                    let str = '{a|' + counts + '}'
                    return str
                  },
                  rich: {
                    a: {
                      fontSize: '16',
                      fontFamily: 'numFont',
                      color: 'rgba(46, 184, 255, 1)'
                    }

                  }
                }
              },
              itemStyle: {
                borderRadius: 0,
                borderColor: '#092729',
                borderWidth: 3
              },
              labelLine: {
                show: true,
                length: 5
              },
              data: o.data
            }

            // 内圈颜色
            // {
            //   color: 'rgba(255,255,255,0)',
            //   // color: new this.$echarts.graphic.RadialGradient(0.5, 0.5, 0.8, [{
            //   //   offset: 1,
            //   //   color: 'rgba(71,239,190,0.4)'
            //   // },
            //   // {
            //   //   offset: 0,
            //   //   color: 'rgba(71,239,190,0)'
            //   // }
            //   // ]), // 内圆颜色
            //   type: 'pie',
            //   radius: '40%',
            //   center: ['50%', '50%'],
            //   // 设置圆的位置，两个圆的位置必须一致
            //   data: [{
            //     value: 100,
            //     name: ''
            //   } // 只设置一个值占整圆
            //   ],
            //   emphasis: {
            //     scale: false // 鼠标悬停到内圆时，取消放大效果
            //   },
            //   label: {
            //     show: false // 关闭牵引线
            //   }
            // }
          ]
        }
        this.myChart.setOption(option)
        window.addEventListener('resize', this.onWindowResize)
      }
    },
    onWindowResize () {
      if (this.myChart) {
        this.myChart.resize()
      }
    }
  },
  watch: {
    echartData (newVal, logVal) {
      const data1 = newVal.data.map(item => {
        const target = {
          ...item
        }
        target.itemStyle = {
          opacity: 0.3
        }
        return target
      })
      this.getChart({
        data: newVal.data,
        data1,
        color: newVal.color,
        count: newVal.count
      })
    }
  }
}

</script>

<style scoped>
.info {
  width: 100%;
  position: absolute;
  bottom: -0.4rem;
  color: rgba(202, 229, 255, 1);
  font-size: 0.78rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/ChartPie/ChartPie1.vue